import { useMutation } from 'react-query';
import env from '~/src/utils/env';
import { useCurrentOrgFprint } from '../../user';
import { fetchAndParse, useInvalidateQuery } from '../../utils';
import { keys } from '../keys';
import { keys as userKeys } from '../../user/keys';

export type WelcomeFormQuestionAnswer = {
  question: string;
  answer: string;
};

export type WelcomeFormData = WelcomeFormQuestionAnswer[];

export const getWelcomeFormSubmitUrl = (orgFprint: string) =>
  `${env.apiUrl}/clients/api/v1/org/${orgFprint}/questionnaire/`;

export type SubmitWelcomeFormVariables = {
  payload: WelcomeFormData;
};

export const useSubmitWelcomeForm = () => {
  const orgFprint = useCurrentOrgFprint();
  const invalidateWelcomeForm = useInvalidateQuery(keys.all);
  const invalidateMemberships = useInvalidateQuery(userKeys.memberships());

  return useMutation({
    mutationFn: ({ payload }: SubmitWelcomeFormVariables) =>
      fetchAndParse(getWelcomeFormSubmitUrl(orgFprint), {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      }),
    onSuccess: async () => {
      try {
        await Promise.all([invalidateWelcomeForm(), invalidateMemberships()]);
      } catch {
        // If cache invalidation fails, avoid user being stuck on welcome form
        window.location.href = '/';
      }
    },
  });
};
